import { render, staticRenderFns } from "./AccountProducts.vue?vue&type=template&id=92eb9254&"
import script from "./AccountProducts.vue?vue&type=script&lang=ts&"
export * from "./AccountProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports